// @custom — Product-specific landing page content overrides.
// This file is NEVER overwritten during template sync.
// Override any keys from @system/landing.js here.

export default {
  heroTitle: "Cluboria",
  heroSubtitle: "Your Club. Your Tactics. Your Legacy.",
  ctaButton: "Get Started",
}
